import { render, staticRenderFns } from "./G.vue?vue&type=template&id=d1d36524&scoped=true&"
import script from "./G.vue?vue&type=script&lang=js&"
export * from "./G.vue?vue&type=script&lang=js&"
import style0 from "./G.vue?vue&type=style&index=0&id=d1d36524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d36524",
  null
  
)

export default component.exports